export default __webpack_public_path__ + "static/media/icn-license.644fd8bd.svg";